import * as React from 'react';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import styled from '@nexus/lib-react/dist/theme/styled';
import { Headline3, Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import { Link } from '@nexus/lib-react/dist/core/Button/ButtonBase';
import File from '@olxeu-a2b/ui/src/commons/components/icons/File';
import { useI18n } from '../../../../i18n';

export interface VerificationUpfrontModalProps {
  handleCloseModal: () => void;
  triggerVerificationUpfrontUrl: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onTrackEvent: Function;
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VerificationUpfrontModal = ({
  handleCloseModal,
  triggerVerificationUpfrontUrl,
  onTrackEvent,
}: VerificationUpfrontModalProps) => {
  const i18n = useI18n();
  const trackEvent = onTrackEvent();
  const trackingEventProps = {
    touch_point_page: 'delivery_kyc_tab',
    touch_point_button: 'kyc_upfront_popup',
    psp: 'PayU',
  };

  return (
    <Modal
      padding="s"
      position="center"
      onClose={handleCloseModal}
      footer={
        <Modal.Footer>
          <ButtonTertiaryDark
            onClick={() => {
              handleCloseModal();
              trackEvent('delivery_kyc_upfront_cancel', null, null, trackingEventProps);
            }}
          >
            {i18n`dlv_statusKyc_verificationUpfrontModal_secondaryButton`}
          </ButtonTertiaryDark>
          <ButtonPrimaryDark
            onClick={() =>
              Promise.resolve()
                .then(() => {
                  trackEvent('delivery_kyc_upfront_confirm', null, null, trackingEventProps);
                })
                .then(() => {
                  window.location.assign(triggerVerificationUpfrontUrl);
                })
            }
            ml="40px"
          >
            {i18n`dlv_statusKyc_verificationUpfrontModal_primaryButton`}
          </ButtonPrimaryDark>
        </Modal.Footer>
      }
    >
      <Container>
        <File />
        <Headline3 mt="24px" mb="16px">
          {i18n`dlv_statusKyc_verificationUpfrontModal_title`}
        </Headline3>
        <Paragraph4 mb="24px">
          {i18n`dlv_statusKyc_verificationUpfrontModal_description_1`}
          <b>{i18n`dlv_statusKyc_verificationUpfrontModal_description_2`}</b>
        </Paragraph4>
      </Container>
    </Modal>
  );
};

export default VerificationUpfrontModal;
